import React from "react"
import Text from "~/ui/typography"

export const LettermemeFooter: React.FC = () => {
  return (
    <div className="mt-14 text-gray-400">
      <Text as="div">
        Lettermeme / Hearsay is a project from{" "}
        <a href="https://wlessin.com/" className="text-white underline">
          sam lessin
        </a>
        ... I built this because there are a lot of newsletters I want to read / be on top of... but
        need a tool to know where to focus, because I get too many of them. I will be building out a
        twitter feed of this at{" "}
        <a className="text-white underline" href="https://x.com/lettrmeme">
          @lettrmeme
        </a>
      </Text>
    </div>
  )
}
